export function isPresent(obj: any): boolean {
  return obj !== undefined && obj !== null;
}

export function isBlank(obj: any): boolean {
  return obj === undefined || obj === null;
}

export function isBoolean(obj: any): boolean {
  return typeof obj === 'boolean';
}

export function isNumber(obj: any): boolean {
  if(typeof obj === 'number') {
    return !isNaN(obj);
  }
  return obj && !isNaN(+obj);
}

export function isString(obj: any): obj is string {
  return typeof obj === 'string';
}

export function isObject(o: any): boolean {
  return o !== null && typeof o === 'object';
}

export function isArray(obj: any): boolean {
  return Array.isArray(obj);
}

export function isEmptyObject(obj: any) {
  return JSON.stringify(obj) === '{}';
}

export function equalArrays(array1: Array<any>, array2: Array<any>) {
  const isSame =
    array1.length === array2.length &&
    array1.every((element: any, index: any) => {
      return element === array2[index];
    });
  return isSame;
}

export function deepCopy(oldObj: any) {
  const clone = JSON.parse(JSON.stringify(oldObj));
  return clone;
}

export function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

export function wait(time) {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}

export function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}
